"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultFilters_1 = __importDefault(require("./DefaultFilters"));
const deepMapProperty = (arr = [], key, valueFn) => {
    return arr.map((elem) => {
        let newElem = elem;
        if (Object.prototype.hasOwnProperty.call(elem, key)) {
            newElem = Object.assign(Object.assign({}, newElem), { [key]: deepMapProperty(elem[key], key, valueFn) });
        }
        return Object.assign(Object.assign({}, newElem), valueFn(elem));
    });
};
const augmentColumnsWithFilters = (columns) => deepMapProperty(columns, 'columns', (column) => !column.filter || column.disableFilters
    ? {}
    : { Filter: column.Filter || DefaultFilters_1.default[column.filter] });
exports.default = augmentColumnsWithFilters;
//# sourceMappingURL=augmentColumnsWithFilters.js.map